export default __webpack_public_path__ + "static/NotoSans-BoldItalic.subset-27d4da8eb486abf2a1d2dc98f9ec9f61.woff2";